import { render, staticRenderFns } from "./ed-consolidate-homeworks.component.vue?vue&type=template&id=183fd139&"
import script from "./ed-consolidate-homeworks.component.ts?vue&type=script&lang=ts&"
export * from "./ed-consolidate-homeworks.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-consolidate-homeworks.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports